<template>
	<div class="center_quote_order_box">
		<!-- 标题 -->
		<center-title>{{$t("message.cqorder.title")}}</center-title>
		<!-- 内容区域 -->
		<div class="center_quote_order">
			<!-- 搜索区域 -->
			<quote-order-search @handle-search="getData(sortAttr, sortMode)">
			</quote-order-search>
			<!-- 表格部分 -->
			<quote-order-table :prop-attr="sortAttr" :order="sortMode" :current-page="page.current_page"
				:page-count="page.last_page" @current-change="handleCurrent" @handle-export="handleExport"
				@selection-change="handleSelectionChange"
				@handleSort="handleSort">
			</quote-order-table>
			<!-- 模态框 -->
			<quote-order-dialog></quote-order-dialog>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapActions,
		mapMutations
	} from "vuex";
	import {
		tableRouterView
	} from "@/utils/publicMethod.js";

	export default {
		mixins: [tableRouterView],
		computed: mapState({
			power: state => state.user.power,
			page: state => state.user.page
		}),
		components: {
			centerTitle: () => import("@/components/center/centerTitle"),
			quoteOrderSearch: () => import("@/components/center/quoteOrderSearch"),
			quoteOrderTable: () => import("@/components/center/quoteOrderTable"),
			quoteOrderDialog: () => import("@/components/center/quoteOrderDialog"),
		},
		methods: {
			...mapMutations([
				"setQuoteOrderList",
				"handleDialog",
				'setPage'
			]),
			...mapActions([
				"getQuoteOrderList",
				"exportQuotationCarOrder"
			]),
			//導出
			handleExport() {
				
				let list = this.selectedList.map(element => {
					return element.quote_id
				});
				if (list.length == 0) {
					this.$message({
						showClose: true,
						message: '請選擇導出報價車訂單',
						type: "error"
					})
					return
				}
				let id = list.join();
				let url = this.$URL.baseUrl + "index/quoteorder/quote_excel?lang=cn&quote_id=" + id;
				window.open(url);
			},

			getData(attr, mode, page = 1) {
				let release = sessionStorage.getItem('release') || '',
					relend = sessionStorage.getItem('relend') || '',
					selected_tabs = sessionStorage.getItem('selected_tabs') || '0',
					complete_status = '';
				switch (Number(selected_tabs)) {
					case 1:
						complete_status = 10;
						break;
					case 2:
						complete_status = 5;
						break;
					case 3:
						complete_status = 15;
						break;
				}
				this.getQuoteOrderList({
					release,
					relend,
					complete_status,
					attr,
					mode,
					page
				})
			},
			changeRouter(search, attr, mode, page = 1) {
				this.$router.push({
					name: 'quoteOrder',
					query: {
						attr,
						mode,
						page
					}
				}).catch(err => err)
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				setTimeout(() => {
					let allow = vm.power.includes(0) || vm.power.includes(111) || vm.power.includes(19),
						{
							attr = '',
							mode = '',
							page = 1
						} = to.query;
					if (allow) {
						vm.getData(attr, mode, page);
					} else {
						vm.$router.back();
						return false;
					}
				}, 500)
			})
		},
		beforeRouteUpdate(to, from, next) {
			let {
				attr,
				mode,
				page
			} = to.query;

			this.getData(attr, mode, page)
			next();
		},
		beforeRouteLeave(to, from, next) {
			this.setQuoteOrderList([]);
			this.handleDialog(false);
			this.setPage({});
			sessionStorage.removeItem("selected_tabs");
			sessionStorage.removeItem("release");
			sessionStorage.removeItem("relend");
			next();
		}
	}
</script>

<style scoped>
	.center_quote_order {
		background: #fff;
	}
</style>
